/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ZerogDailyTrxInfo } from './ZerogDailyTrxInfo';

export type ZerogHomeTotalTrxInfo = {
    TRXHTP: ZerogHomeTotalTrxInfo.TRXHTP;
    TRXTP: ZerogHomeTotalTrxInfo.TRXTP;
    DAVGTRXC: string;
    CNGP: string;
    DTRXLIST: Array<ZerogDailyTrxInfo>;
};

export namespace ZerogHomeTotalTrxInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
        CLAIM = 'CLAIM',
        DEPOSIT = 'DEPOSIT',
        USER = 'USER',
        AVG_GAS_PRICE = 'AVG_GAS_PRICE',
    }


}

